function ensureLabelLength(value) {
  const CHAR_LIMIT = 50

  if (value.length <= CHAR_LIMIT) return value

  return `${value.slice(0, CHAR_LIMIT)}...`
}

export default ensureLabelLength
